export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/noop.js
// module id = ./node_modules/d3-shape/src/noop.js
// module chunks = 53